<template>
    <div id="tool_core_waybill_card_buttons" class="ui fluid buttons">
        <BtnPrint v-if="is_can_print_label"
            :is_enable_auto_print_label="is_enable_auto_print_label"
            :core_waybill="core_waybill"
            :eventbus="eventbus">
        </BtnPrint>

        <BtnAction v-if="is_can_update"
            :core_waybill="core_waybill"
            :eventbus="eventbus"

            :active_button_color="active_button_color"
            :active_button_content="active_button_content"
            :active_button_channel="active_button_channel">
        </BtnAction>

        <BtnMain v-if="!is_can_update"
            :core_waybill="core_waybill"
            :eventbus="eventbus"
            :active_button_to_detail_route_name="active_button_to_detail_route_name"
            :is_show_change_template_btns="is_show_change_template_btns">
        </BtnMain>
    </div>
</template>

<script>
import BtnAction from '@toolbox/core_waybill/card_partials/button_partials/action.vue'
import BtnPrint from '@toolbox/core_waybill/card_partials/button_partials/print.vue'
import BtnMain from '@toolbox/core_waybill/card_partials/button_partials/main.vue'

export default {
    components: {
        BtnAction,
        BtnPrint,
        BtnMain,
    },
    props: {
        /*
         * Main
         */
        core_waybill: {
            default: {},
            type: Object
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },

        /*
         * 共用
         */
        is_enable_auto_print_label: {
            default: false,
            type: Boolean
        },
        is_show_change_template_btns: {
            default: false,
            type: Boolean
        },
        is_can_print_label: {
            default: false,
            type: Boolean
        },
        is_can_update: {
            default: false,
            type: Boolean
        },

        /*
         * active button options
         */
        active_button_color: {
            default: "blue",
            type: String
        },
        active_button_content: {
            default: "更新",
            type: String
        },
        active_button_channel: {
            default: "",
            type: String
        },
        active_button_to_detail_route_name: {
            default: "",
            type: String
        },
    },
    data() {
        return {
            is_processing: false,
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
    // 非常小的螢幕時, 如honeywell
    @media only screen and (max-width: 370px) {
        #tool_core_waybill_card_buttons .button {
            padding-left: 0.5em !important;
            padding-right: 0.5em !important;
        }
    }
    #tool_core_waybill_card_buttons {
        .ui.buttons {
            padding: 0;
        }
        .ui.buttons div {
            padding: .78571429em 1.5em .78571429em;
        }
    }
</style>
